import React, { useState } from "react";
import styled from "styled-components";
import { Paper, Tooltip, Alert } from "@mui/material";
import { Modal, Button } from "@mui/material";
import SuperDisguise from "./SuperDisguise";
import BypassReportPermissions from "./BypassReportPermissions";
import useGlobalStore from "src/store/useGlobalStore";

const ModalWrapper = styled(Paper)`
  padding: 14px;
  width: calc(min(500px, 96vw));
  min-height: 240px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid black;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const SuperDisguiseButton = styled(Button)`
  height: 32px;
  width: 32px;
  max-width: 32px;
  min-width: 32px;
  padding: 0px;
  background: #eeeeee40;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  border: 1px dashed #eeeeee;
  filter: grayscale(1);
  transition: filter 200ms ease-in;

  &:hover {
    filter: grayscale(0);
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const TAB_OPTIONS = {
  COMPANY_DISGUISE: "Company Disguise",
  BYPASS_PERMISSIONS: "Bypass Permissions",
};

const TypeButton = styled(Button)`
  height: 26px;
  min-width: 86px;
  width: fit-content;
  background: ${(props) => (props?.$isActive ? "aliceblue" : "white")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
  cursor: pointer;
  border: ${(props) => (props?.$isActive ? 2 : 1)}px solid
    ${(props) => (props?.$isActive ? "#337ab7" : "#eeeeee")};

  span {
    font-size: 12px;
    color: ${(props) => (props?.$isActive ? "black" : "slategrey")};
    font-weight: ${(props) => (props?.$isActive ? 500 : 400)};
  }
`;

const SelectorWrap = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  justify-content: center;
`;

const SelectorBtnWrap = styled.div`
  padding: 2px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const ModalUI = ({ handleClose }) => {
  const [activeTab, setActiveTab] = useState(TAB_OPTIONS.COMPANY_DISGUISE);
  const [error, setError] = useState(null);
  const byPassValue = useGlobalStore(
    (state) => state.config?.user?.can_bypass_report_permissions,
  );

  return (
    <ModalWrapper>
      <p style={{ fontSize: 16, fontWeight: 600 }}>Superuser Panel</p>
      <div style={{ minHeight: 6 }} />
      <SelectorWrap>
        <SelectorBtnWrap>
          <TypeButton
            size="small"
            $isActive={activeTab === TAB_OPTIONS.COMPANY_DISGUISE}
            onClick={() => setActiveTab(TAB_OPTIONS.COMPANY_DISGUISE)}
          >
            <span>{TAB_OPTIONS.COMPANY_DISGUISE}</span>
          </TypeButton>
          <TypeButton
            size="small"
            $isActive={activeTab === TAB_OPTIONS.BYPASS_PERMISSIONS}
            onClick={() => setActiveTab(TAB_OPTIONS.BYPASS_PERMISSIONS)}
          >
            <span>{TAB_OPTIONS.BYPASS_PERMISSIONS}</span>
          </TypeButton>
        </SelectorBtnWrap>
      </SelectorWrap>
      <div style={{ minHeight: 18 }} />
      <ContentContainer>
        {activeTab === TAB_OPTIONS.COMPANY_DISGUISE && (
          <SuperDisguise setError={setError} handleClose={handleClose} />
        )}
        {activeTab === TAB_OPTIONS.BYPASS_PERMISSIONS && (
          <BypassReportPermissions
            byPassValue={byPassValue}
            setError={setError}
          />
        )}
      </ContentContainer>
      {error && (
        <>
          <div style={{ height: 12 }} />
          <Alert
            severity="error"
            onClose={() => setError(null)}
            style={{ border: "1px solid firebrick", width: "100%" }}
          >
            <p style={{ fontWeight: 600, fontSize: 14 }}>Error</p>
            <p>{error}</p>
          </Alert>
        </>
      )}
    </ModalWrapper>
  );
};

const SuperModal = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip arrow title="Superuser Actions">
        <SuperDisguiseButton
          onClick={() => setOpen((p) => !p)}
          variant="outlined"
        >
          <span>🕵️</span>
        </SuperDisguiseButton>
      </Tooltip>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div>
          <ModalUI handleClose={() => setOpen(false)} />
        </div>
      </Modal>
    </>
  );
};

export default SuperModal;
